import { z } from 'zod';
/**
 * The lifecycle of the `PREVISIT` workflow attached to an encounter or EHR information record.
 * Named for the workflow rather than the form set because a set is only one of the things the
 * statuses describe: the first four cover the outreach that precedes any form being opened.
 */
export var PrevisitWorkflowStatus;
(function (PrevisitWorkflowStatus) {
    PrevisitWorkflowStatus["Created"] = "CREATED";
    PrevisitWorkflowStatus["MessageSent"] = "MESSAGE_SENT";
    PrevisitWorkflowStatus["MessageUndelivered"] = "MESSAGE_UNDELIVERED";
    PrevisitWorkflowStatus["MessageDelivered"] = "MESSAGE_DELIVERED";
    PrevisitWorkflowStatus["CannotReceiveNotification"] = "CANNOT_RECEIVE_NOTIFICATION";
    PrevisitWorkflowStatus["FormSetStarted"] = "FORM_STARTED";
    PrevisitWorkflowStatus["FormSetCompleted"] = "FORM_COMPLETED";
    PrevisitWorkflowStatus["FormSetExpired"] = "FORM_EXPIRED";
})(PrevisitWorkflowStatus || (PrevisitWorkflowStatus = {}));
export const PrevisitWorkflowStatusSchema = z.enum(PrevisitWorkflowStatus);
//# sourceMappingURL=workflowStatus.js.map